var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompleteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1115_27974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 0.28125C4.19625 0.28125 0.28125 4.19625 0.28125 9C0.28125 13.8038 4.19625 17.7188 9 17.7188C13.8038 17.7188 17.7188 13.8038 17.7188 9C17.7188 4.19625 13.8038 0.28125 9 0.28125ZM9 16.0312C5.11875 16.0312 1.96875 12.8813 1.96875 9C1.96875 5.11875 5.11875 1.96875 9 1.96875C12.8813 1.96875 16.0312 5.11875 16.0312 9C16.0312 12.8813 12.8813 16.0312 9 16.0312Z",
    fill: "#58BD7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3301 5.53497L7.18883 10.6762L5.68133 9.16872C5.35508 8.84247 4.81508 8.84247 4.48883 9.16872C4.16258 9.49497 4.16258 10.035 4.48883 10.3612L6.59258 12.465C6.75008 12.6337 6.97508 12.7125 7.18883 12.7125C7.40258 12.7125 7.61633 12.6337 7.78508 12.465L13.5226 6.72747C13.8488 6.40122 13.8488 5.86122 13.5226 5.53497C13.1963 5.20872 12.6563 5.20872 12.3301 5.53497Z",
    fill: "#58BD7D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1115_27974"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteIcon);
export default __webpack_public_path__ + "static/media/complete-icon.cb60f57cbae73003e0ff3af94e35a826.svg";
export { ForwardRef as ReactComponent };